import React from "react";
import Card from "components/card";

const ProgramEmployeeCard = ({
    initials,
    name,
    role,
    employee_id,
    onClick,
    selected = false,
    progress,
    milestone,
    hours,
}) => {
    return (
        <Card
            hoverable
            onClick={onClick}
            className={`!rounded-2xl !border-2 transition-all duration-300 cursor-pointer ${
                selected
                    ? "!border-purple-500  !bg-purple-50/30"
                    : "!border-slate-200 hover:!border-purple-300"
                }`}
        >
            <div className="p-4 pb-6">
                <div className="flex items-start gap-3 mb-3">
                    <span 
                        className={`relative flex w-12 h-12 shrink-0 overflow-hidden rounded-full border-2 border-slate-200 ${
                            selected
                                ? "bg-purple-500"
                                : "bg-slate-100"
                            }`}
                    >
                        <span className={`flex size-full items-center justify-center font-semibold ${
                            selected
                                ? "text-white"
                                : "text-slate-500"
                            }`}
                        >
                            {initials}
                        </span>
                    </span>
                    <div className="flex-1 min-w-0">
                        <h4 className="font-semibold text-[14px]">
                            {name}
                        </h4>
                        <p className="text-[12px] text-slate-500">
                            {role}
                        </p>
                        <span className="status-indicator normal mt-1 text-[9px]">
                            {employee_id}
                        </span>
                    </div>
                </div>
                <div className="space-y-2">
                    <div className="flex items-center justify-between text-[11px]">
                        <span className="text-slate-500">
                            Overall Progress
                        </span>
                        {progress !== undefined && (
                            <span className="font-semibold">{progress}%</span>
                        )}
                    </div>
                    <div className="w-full h-2 rounded-full bg-emerald-100 overflow-hidden">
                        <div
                            className="h-full bg-emerald-500"
                            style={{ width: `${progress}%` }}
                        />
                    </div>
                    <div className="flex items-center justify-between text-[11px] pt-1">
                        <span className="text-slate-500">
                            Milestone {milestone}
                        </span>
                        <span>
                            {hours}
                        </span>
                    </div>
                </div>
            </div>
        </Card>
    );
};

export default ProgramEmployeeCard;